<template>
  <div class="login">
    <div class="return-wrap">
      <!-- <div class="return" @click="submit2">&lt;返回前台</div> -->
    </div>
    <div class="logo">
      <img :src="oem.icon || defaultIcon" :alt="$config.title"/>
    </div>
    <div class="theme">
      <p>{{$t('pages_account_reset_148')}}</p>
    </div>
    <div class="float-block">
      <form id="session-form">
        <div class="form-input-wrap">
          <div class="input-group smsMobile" style="margin-top: 1.5vw">
            <el-select class="countryMobileCode" v-model="countryMobileCode" filterable :placeholder="$t('pages_account_login_133')">
              <el-option
                v-for="item in countryMobileCodes"
                :key="item.value"
                :label="`${item.label} +${item.value}`"
                :value="item.value">
              </el-option>
            </el-select>
            <input type="tel" class="form-control phone-input chengbao-keyboard" :placeholder="$t('pages_account_login_134')" v-model="phone" />
            <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="sendCode">
                <span v-if="isSendCode" style="color: #d6d6d6">{{ countdown }}s</span>
                <span v-if="!isSendCode">{{$t('pages_account_login_135')}}</span>
              </button>
            </span>
          </div>
          <div class="input-group">
            <input type="text" class="form-control captcha-input chengbao-keyboard" :placeholder="$t('pages_account_login_136')" autocomplete="off" v-model="code" />
          </div>
          <div class="input-group">
            <input type="password" class="form-control captcha-input chengbao-keyboard" :placeholder="$t('pages_account_reset_149')" autocomplete="off" v-model="password" />
          </div>
          <div class="input-group">
            <input type="password" class="form-control captcha-input chengbao-keyboard" :placeholder="$t('pages_account_reset_150')" autocomplete="off" v-model="repeatPassword" />
          </div>
          <div class="submit-row">
            <div class="form-submit" @click="submit">{{$t('pages_account_reset_151')}}</div>
          </div>
          <div class="reset-row">
            <div class="reset-wrap">
              <router-link to="/login" class="reset-btn">{{$t('pages_account_reset_152')}}</router-link>
            </div>
          </div>
        </div>
        <div class="tip" v-if="false">
          <input type="checkbox" name="agree_protocol" id="agree_protocol" v-model="isAgreeProtocol" checked="checked" />{{$t('pages_account_login_143')}}<a href="https://www.chengbao68.com/merchant/pages/fuwuxieyi">{{$t('pages_account_reset_153')}}</a>
        </div>
      </form>
      <!-- <p class="operate removed">
           <span>{{若您没有${$config.title}商家账号}}</span>
           {{联系${$config.title}客服开通}}
      </p> -->
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState } from 'vuex'
import axios from 'axios'
import { countryMobileCodes } from '@/libs/value-list'

export default {
  name: 'Reset',
  components: {},
  data () {
    return {
      defaultIcon: this.$config.logo,
      phone: '',
      code: '',
      isAgreeProtocol: true,
      isSendCode: false,
      countdown: 60,
      timer: '',
      // isDisabled: true,
      password: '',
      repeatPassword: '',
      countryMobileCode: '86',
      countryMobileCodes
    };
  },
  watch: {
    // code (val) {
    //   this.btnIsDisabled(val);
    // },
    // phone (val) {
    //   this.btnIsDisabled(val);
    // },
  },
  computed: {
    ...mapState('oem', ['oem'])
  },
  mounted () {},
  methods: {
    sendCode () {
      const inlandMobileReg = /^(1)\d{10}$/
      if (this.timer) return;
      if (this.phone === '') {
        this.$message({
          duration: 1000,
          message: i18n.t('pages_account_login_134'),
          type: 'error',
        });
        return -1;
      }
      // if (!inlandMobileReg.test(this.phone)) {
      //   this.$message({
      //     duration: 1000,
      //     message: '请输入正确的手机号',
      //     type: 'error',
      //   });
      //   return -1;
      // }
      const countryMobile = (inlandMobileReg.test(this.phone) ? '' : this.countryMobileCode) + this.phone
      axios.post('/sessions/sms', {
        mobile: countryMobile,
      }).then(() => {
        this.$message({
          duration: 2000,
          message: i18n.t('pages_account_login_145'),
          type: 'success',
        });
        this.isSendCode = true;
        this.countdownFun();
      }).catch(() => {
        this.$message({
          duration: 2000,
          message: i18n.t('pages_account_login_146'),
          type: 'error',
        });
      });
    },
    countdownFun () {
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(this.timer);
          this.countdown = 60;
          this.isSendCode = false;
        }
      }, 1000);
    },
    // btnIsDisabled (val) {
    //   if (val && val.length === 4 && /^(1)\d{10}$/.test(this.phone)) {
    //     this.isDisabled = false;
    //   } else {
    //     this.isDisabled = true;
    //   }
    // },
    submit () {
      const inlandMobileReg = /^(1)\d{10}$/
      if (!this.phone) {
        this.$message({
          duration: 1000,
          message: i18n.t('components_loginform_4'),
          type: 'error',
        });
        return;
      }
      // if (!inlandMobileReg.test(this.phone)) {
      //   this.$message({
      //     duration: 1000,
      //     message: '请输入正确的手机号',
      //     type: 'error',
      //   });
      //   return;
      // }
      if (!this.code) {
        this.$message({
          duration: 1000,
          message: i18n.t('pages_account_login_147'),
          type: 'error',
        });
        return;
      }
      if (!this.password) {
        this.$message({
          duration: 1000,
          message: i18n.t('components_loginform_5'),
          type: 'error',
        });
        return;
      }
      if (!this.repeatPassword) {
        this.$message({
          duration: 1000,
          message: i18n.t('pages_account_reset_154'),
          type: 'error',
        });
        return;
      }
      if (this.repeatPassword !== this.password) {
        this.$message({
          duration: 1000,
          message: i18n.t('pages_account_reset_155'),
          type: 'error',
        });
        return;
      }
      localStorage.setItem('reMobile', this.phone);
      const countryMobile = (inlandMobileReg.test(this.phone) ? '' : this.countryMobileCode) + this.phone
      axios.post('/sessions/reset_password', {
        mobile: countryMobile,
        code: this.code,
        password: this.password,
        repeat_password: this.repeatPassword,
      }).then(({ data }) => {
        this.$message({
          duration: 1000,
          message: data ? '重置成功' : i18n.t('pages_account_reset_156'),
          type: data ? 'success' : 'error',
        });
        localStorage.setItem('reCountryMobileCode', this.countryMobileCode);
        this.$router.push('/login');
      })
    },
  },
};
</script>

<style lang="scss">
@import './login.scss';
</style>
